/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/**
 * Front-end logic for Bilingual Paragraph
 * Listens to the Navigation class for language changes.
 */

const toggleBilingualBlocks = (lang) => {
	const activeLang = lang || localStorage.getItem("siteLang") || "en";

	// Find all bilingual sections (from your render.php)
	const sections = document.querySelectorAll(".bilingual-section");

	sections.forEach((section) => {
		// Toggle visibility based on data-lang attribute
		if (section.getAttribute("data-lang") === activeLang) {
			section.style.display = "block";
		} else {
			section.style.display = "none";
		}
	});
};

// 1. Initialize on page load
document.addEventListener("DOMContentLoaded", () => {
	toggleBilingualBlocks();
});

// 2. Listen for the custom event dispatched by your Navigation class
window.addEventListener("languageChange", (e) => {
	// e.detail contains the 'lang' string passed from setLanguage()
	toggleBilingualBlocks(e.detail);
});
